import React from 'react'
import PropTypes from 'prop-types'
import {
  ContainerButtons,
  ButtonAmendTrade,
  ButtonDeleted,
  ButtonGiveUp,
  ButtonGroupTrade,
  TradeBlotterTool,
  ButtonReview,
  ButtonClearFilter,
  ButtonCsv,
  ButtonAllocate,
  ChipStyle
} from '../../TradeBlotter.style'
import { Box } from '@mui/material'
import { ReactComponent as BlotterCsvIcon } from '../../../../assets/blotter_csv_report.svg'
import MenuButton from '../MenuButton/MenuButton'
import SearchTextField from '../../../../components/SearchTextField/SearchTextField'
import MenuStatus from '../MenuStatus/MenuStatus'

const TradeBlotterToolBar = ({
  isUserBooking,
  handelGroupButtonRender,
  handelGroupTrade,
  csvExport,
  disabledGroupTrade,
  handelUnGroupDeals,
  disabledUnGroupDeal,
  handelAmendTrade,
  disabledAmendTrade,
  handelDealTradeGiveUp,
  disabledDealGiveUp,
  handelUnAllocateDeal,
  disabledUnAllocatedDeal,
  handelTradeDealDelete,
  disabledDeleteTradeDeal,
  cleanFilters,
  filters,
  handelGlobalFilterIcon,
  handelStatusFilterChange,
  handelDeleteTradingAccountShortnameFilter,
  review,
  handelGlobalSearchFilter,
  handelKeyPress
}) => {
  return (
    <>
      <TradeBlotterTool>
        <ContainerButtons>
          {handelGroupButtonRender() ? (
            <ButtonGroupTrade
              variant="contained"
              onClick={handelGroupTrade}
              disabled={disabledGroupTrade() || !isUserBooking()}
            >
              Group
            </ButtonGroupTrade>
          ) : (
            <ButtonGroupTrade
              variant="contained"
              onClick={handelUnGroupDeals}
              disabled={disabledUnGroupDeal() || !isUserBooking()}
            >
              Ungroup
            </ButtonGroupTrade>
          )}
          <ButtonAmendTrade
            variant="contained"
            onClick={handelAmendTrade}
            disabled={disabledAmendTrade() || !isUserBooking()}
          >
            Amend
          </ButtonAmendTrade>
          <ButtonAllocate
            variant="contained"
            onClick={handelUnAllocateDeal}
            disabled={disabledUnAllocatedDeal() || !isUserBooking()}
          >
            Allocate
          </ButtonAllocate>
          <ButtonGiveUp
            variant="contained"
            onClick={handelDealTradeGiveUp}
            disabled={disabledDealGiveUp() || !isUserBooking()}
          >
            Give-Up
          </ButtonGiveUp>
          <ButtonDeleted
            variant="contained"
            onClick={handelTradeDealDelete}
            disabled={disabledDeleteTradeDeal() || !isUserBooking()}
          >
            Delete
          </ButtonDeleted>
        </ContainerButtons>
        <Box style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
          {filters.trading_account_shortname && (
            <ChipStyle
              label={filters.trading_account_shortname}
              variant="outlined"
              onDelete={handelDeleteTradingAccountShortnameFilter}
            />
          )}
          <ButtonReview
            variant="contained"
            press={String(filters.status_warning_and_union)}
            onClick={() => handelGlobalFilterIcon('status_warning_and_union')}
            disabled={review === 0}
          >
            Review {review && review !== 0 && ` (${review})`}
          </ButtonReview>
          <MenuStatus
            isUserBooking={isUserBooking}
            handelStatusFilterChange={handelStatusFilterChange}
            filters={filters}
          >
            Status
          </MenuStatus>
          <ButtonCsv startIcon={<BlotterCsvIcon />} onClick={csvExport}>
            CSV
          </ButtonCsv>
          <ButtonClearFilter onClick={cleanFilters}>Clear Filters</ButtonClearFilter>
          <SearchTextField
            name="search"
            handleChange={handelGlobalSearchFilter}
            handelKeyPress={handelKeyPress}
            state={filters.search}
          />

          <MenuButton isUserBooking={isUserBooking} />
        </Box>
      </TradeBlotterTool>
    </>
  )
}
export default TradeBlotterToolBar

TradeBlotterToolBar.propTypes = {
  isUserBooking: PropTypes.func,
  csvExport: PropTypes.func,
  handelGroupButtonRender: PropTypes.func,
  handelGroupTrade: PropTypes.func,
  disabledGroupTrade: PropTypes.func,
  handelUnGroupDeals: PropTypes.func,
  disabledUnGroupDeal: PropTypes.func,
  handelAmendTrade: PropTypes.func,
  disabledAmendTrade: PropTypes.func,
  handelAllocateTrade: PropTypes.func,
  disabledAllocateTrade: PropTypes.func,
  handelDealTradeGiveUp: PropTypes.func,
  disabledDealGiveUp: PropTypes.func,
  handelTradeDealDelete: PropTypes.func,
  handelDeleteTradingAccountShortnameFilter: PropTypes.func,
  disabledDeleteTradeDeal: PropTypes.func,
  handelUnAllocateDeal: PropTypes.func,
  disabledUnAllocatedDeal: PropTypes.func,
  cleanFilters: PropTypes.func,
  filters: PropTypes.object,
  setFilters: PropTypes.func,
  handelGlobalFilterIcon: PropTypes.func,
  handelStatusFilterChange: PropTypes.func,
  page: PropTypes.number,
  setPage: PropTypes.func,
  review: PropTypes.number,
  cleanCheckBoxState: PropTypes.func,
  handelGlobalSearchFilter: PropTypes.func,
  handelKeyPress: PropTypes.func
}
